__turbopack_context__.v({
  "container": "LYDhkq_container",
  "qrCodeDynamic": "LYDhkq_qrCodeDynamic",
  "qrCodeDynamic--lg": "LYDhkq_qrCodeDynamic--lg",
  "qrCodeDynamic--md": "LYDhkq_qrCodeDynamic--md",
});
